import Vue from 'vue'
import Vuex from 'vuex'
// import Camera from 'vue-camera-snapshot'
import VueScrollActive from 'vue-scrollactive'
import VuexStore from '../store'

import App from './App.vue'

import createPersistedState from 'vuex-persistedstate';

//import fontawesome
import './assets/fonts/fonts.css';

// import fontawesome
import './assets/fontawesome/all.min.css';

//import SweetAlert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(Vuex)
// Vue.use(Camera)
Vue.use(VueScrollActive)

const store = new Vuex.Store({
    ...VuexStore,
    plugins: [
        createPersistedState({})
    ]
})


import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from './Home.vue'
import ODTF from './Camera/ODTF.vue'
import Manual from './Camera/Manual.vue'
import ResultPage from './ResultPage.vue'

const router = new VueRouter({
    mode : 'history',
    routes: [
        { path: '/', component: Home },
        { path: '/manual', component: Manual },
        { path: '/automatic', component: ODTF },
        { path: '/result' , component: ResultPage, name : "ResultPage"}
    ]
})

import axios from 'axios';

axios.get('/api/data', {
  headers: {
    'Cache-Control': 'max-age=3600'
  }
})
.then(response => {
  // handle response
})
.catch(error => {
  // handle error
});


new Vue({
    router,
    render : h => h(App),
    store
}).$mount('#app')